import React from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { DeliveryIcon, FlagIcon, CheckCircleGreenIcon, AddCartIcon } from 'ui-component/custom-icons/icons';


// ✅ Clear
const BreadcrumbsMobile = ({ status, disabled }) => {

    
    return (
        <div style={{ display: 'flex', gap: 10, justifyContent: 'space-evenly', padding: '4px 20px', alignItems: 'center' }}>
            <div style={{ position: 'relative' }}>
                <div className={`new-breadcrumbs-btn`}>
                    <AddCartIcon width="18px" height="18px" />
                    Pick Products
                </div>
                {status === 'Closed' && (
                    <div style={{ position: 'absolute', top: '-6px' }}>
                        <CheckCircleGreenIcon width={'15px'} height={'15px'} />
                    </div>
                )}
            </div>
            <FiChevronRight size={14} />
            <div style={{ position: 'relative' }}>
                <div className={`new-breadcrumbs-btn`}>
                    <DeliveryIcon width="18px" height="18px" />
                    Create Shipment
                </div>
                {status === 'Closed' && (
                    <div style={{ position: 'absolute', top: '-6px' }}>
                        <CheckCircleGreenIcon width={'15px'} height={'15px'} />
                    </div>
                )}
            </div>
            <FiChevronRight size={14} />
            <div style={{ position: 'relative' }}>
                <div className={`new-breadcrumbs-btn`}>
                    <FlagIcon width="12px" height="12px" />
                    Close Picklist
                </div>
                {status === 'Closed' && (
                    <div style={{ position: 'absolute', top: '-6px' }}>
                        <CheckCircleGreenIcon width={'15px'} height={'15px'} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default BreadcrumbsMobile;
